import { render, staticRenderFns } from "./notasVersao.vue?vue&type=template&id=b8a9bbb8&"
import script from "./notasVersao.vue?vue&type=script&lang=js&"
export * from "./notasVersao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports